// extracted by mini-css-extract-plugin
export default {"content":"editor-footer_content__bU7Fe","error":"editor-footer_error__GN+FB","helperText":"editor-footer_helperText__5p1xU"};